import { defineStore } from 'pinia'
import type { Ref } from 'vue'
import { ref } from 'vue'

export interface VersionStoreState {
  updateAvailable: Ref<boolean>
  latestVersion: Ref<string | null>
  dismissed: Ref<boolean>
  setUpdateAvailable: (available: boolean, version: string | null) => void
  dismissUpdate: () => void
  resetDismiss: () => void
}

export const useVersionStore = defineStore('versionStore', (): VersionStoreState => {
  const updateAvailable = ref(false)
  const latestVersion = ref<string | null>(null)
  const dismissed = ref(false)

  function setUpdateAvailable(available: boolean, version: string | null) {
    updateAvailable.value = available
    latestVersion.value = version
    // Reset dismiss flag when new version is detected
    if (available) {
      dismissed.value = false
    }
  }

  function dismissUpdate() {
    dismissed.value = true
  }

  function resetDismiss() {
    dismissed.value = false
  }

  return {
    updateAvailable,
    latestVersion,
    dismissed,
    setUpdateAvailable,
    dismissUpdate,
    resetDismiss
  }
})
